import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authed/applications/$applicationId')({
  component: () => <Outlet />,
})
